module.exports = __webpack_public_path__ + "img/AI (8).dac074f4.png";